import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Breadcrumb from '../../components/ui/Breadcrumb';
import AccountNav from './components/AccountNav';
import ProfileForm from './components/ProfileForm';

const AccountProfile = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const breadcrumbItems = [
    { label: 'Dashboard', path: '/dashboard' },
    { label: 'Account Settings', path: '#' },
    { label: 'Profile', path: '/account-profile' }
  ];

  return (
    <div className="relative min-h-screen w-full overflow-hidden">
      <div className="fixed inset-0 -z-10 bg-[url('/assets/images/medical.jpg')] bg-cover bg-center bg-no-repeat" />
      <div className="fixed inset-0 -z-10 bg-black/75" />

      <div className="relative z-10 min-h-screen overflow-y-auto pb-24">
        <Header />

        <div className="pt-10 px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="mb-8">
              <Breadcrumb items={breadcrumbItems} />
            </div>

            <div className="flex gap-8">
              {/* Sidebar Navigation */}
              <div className="w-64 shrink-0">
                <AccountNav currentPath={location?.pathname} />
              </div>

              {/* Main Content Area */}
              <div className="flex-1 max-w-2xl">
                <div className="mb-6">
                  <h1 className="text-3xl font-light text-white tracking-tight">Profile Information</h1>
                  <p className="mt-2 text-slate-300">
                    Manage your personal information and profile settings.
                  </p>
                </div>

                {/* Profile Form Card */}
                <div className="bg-white/5 backdrop-blur-lg border border-white/10 rounded-2xl shadow-xl">
                  <ProfileForm />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountProfile;